export default class DefaultTeamCategory {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        $(document).ready(function(){
            // Redirect the page to the selected default category
            const buttonUrl = $("#filter-pills-default").attr('href');
            const currentUrl = window.location.href;

            if(buttonUrl) {
                window.location.href = currentUrl+'/'+buttonUrl;
                return false;
            }
        });

    }
};

new DefaultTeamCategory();